import { render, staticRenderFns } from "./otherCSV.vue?vue&type=template&id=82662e76&scoped=true&"
import script from "./otherCSV.vue?vue&type=script&lang=js&"
export * from "./otherCSV.vue?vue&type=script&lang=js&"
import style0 from "./otherCSV.vue?vue&type=style&index=0&id=82662e76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82662e76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
